(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('pl-announcement-ticker')){
    customElements.define('pl-announcement-ticker',class extends HTMLElement{
      connectedCallback(){
        this.original=this.querySelector('[data-original]');
        this.track=this.querySelector('.pl-announcement__track');
        if(!this.original||!this.track)return;
        this.refresh();
        this.observer=new MutationObserver(()=>this.refresh());
        this.observer.observe(this.original,{childList:true,subtree:true,characterData:true});
      }
      refresh(){
        this.track.querySelectorAll('[data-copy]').forEach(element=>element.remove());
        const copy=this.original.cloneNode(true);
        copy.removeAttribute('data-original');
        copy.setAttribute('data-copy','');
        copy.setAttribute('aria-hidden','true');
        copy.setAttribute('inert','');
        [copy,...copy.querySelectorAll('*')].forEach(element=>{
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
          element.removeAttribute('data-shopify-editor-section');
          element.removeAttribute('aria-describedby');
          element.removeAttribute('aria-labelledby');
        });
        this.track.appendChild(copy);
        this.setAttribute('data-ready','');
      }
      disconnectedCallback(){if(this.observer)this.observer.disconnect();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
